// extracted by mini-css-extract-plugin
export default {"App":"BaseAppView_App__mSgkG","Column":"BaseAppView_Column__2D7lq"};